import { Component, OnInit } from '@angular/core';
import {UtilService} from '../iBoxx/services/UtilService';
import {ApiService} from '../iBoxx/services/api.service';
import {PagingModel} from '../iBoxx/shared/pagination-control/PagingModel';
// @ts-ignore
import {Index} from '../iBoxx/modals/Index';
import {GridReadyEvent} from 'ag-grid-community';
import {Router} from '@angular/router';
import {LoaderService} from '../iBoxx/shared/loader/loader-service.services';

@Component({
  selector: 'app-ucits-landing-page',
  templateUrl: './ucits-landing-page.component.html',
  styleUrls: ['./ucits-landing-page.component.scss']
})
export class UcitsLandingPageComponent implements OnInit {

  columnDefs = [
    {
      headerName: 'Index Name', width: 300, maxWidth: 500, field: 'indexName',
      pinned: 'left', sortable: true,
      cellRenderer: (params: any) => {
        return params.data.indexName === null ? '' : '<span class="link">' + params.value + '</span>';
      },
      onCellClicked: (param: any) => {
        this.getIndexDetailsFor(param.data.id);
      },
      comparator: ((valueA: string, valueB: string) => valueA.toUpperCase() < valueB.toUpperCase() ? -1 : 1)
    },
    {headerName: 'ISIN', width: 110, field: 'isinTri', sortable: true},
    {headerName: 'As Of Date', width: 90, field: 'asOf', sortable: true, comparator: () => 0},
    {headerName: 'Fixing', width: 80, field: 'fixing', sortable: true, comparator: () => 0},
    {headerName: 'TRI Level', width: 80, field: 'totalReturnIndex', sortable: true,
      comparator: () => 0},
    {headerName: 'Daily %', width: 80, field: 'dailyReturn', sortable: true,
      comparator: () => 0 },
    {headerName: 'MTD %', width: 80, field: 'monthToDateReturn', sortable: true,
      comparator: () => 0 },
    {headerName: 'QTD %', width: 80, field: 'quarterToDateReturn', sortable: true,
      comparator: () => 0 },
    {headerName: 'YTD %', width: 80, field: 'yearToDateReturn', sortable: true,
      comparator: () => 0 },
    {headerName: 'No. of Constituents', headerTooltip: 'No. of Constituents', width: 120, field: 'bondsCount', sortable: true,
      comparator: () => 0 },
  ];

  rowData: Index[] = [];
  pagingInfo: PagingModel = new PagingModel();
  indexGrid: any;

  constructor(private utilService: UtilService, private apiService: ApiService, private route: Router, private loader: LoaderService) { }

  ngOnInit(): void {
    this.fetchUCITS();
  }

  onGridReady(event: GridReadyEvent): void {
    this.indexGrid = event.api;
    this.changePage();
  }

  fetchUCITS(): void{
    this.loader.show();
    this.apiService.getHeadlineIndices().subscribe((resp: any) => {
      this.populateIndexData(this.formatDate(this.utilService.getRecordsForInvestmentType('ETFs_Funds', resp.headlineIndices)));
      this.loader.hide();
    });
  }

  populateIndexData(result: any): void {
    this.rowData = [];
    result.forEach((res: any) => {
      const idx: Index = new Index();
      idx.id = res.id;
      idx.indexName = res.indexName;
      idx.isinTri = res.isinTri;
      idx.asOf = this.utilService.formatDate(res.asOf);
      idx.fixing = res.fixing.toUpperCase();
      idx.totalReturnIndex = res.totalReturnIndex ? parseFloat(res.totalReturnIndex).toFixed(4) : '';
      idx.dailyReturn = res.dailyReturn;
      idx.monthToDateReturn = res.monthToDateReturn;
      idx.quarterToDateReturn = res.quarterToDateReturn;
      idx.yearToDateReturn = res.yearToDateReturn;
      idx.bondsCount = res.numberOfInstruments ? res.numberOfInstruments : res.bondsCount;

      this.rowData.push(idx);
    });
    this.initPaging();
  }

  onRowSelected(): void {
    const selectedNodes = this.indexGrid.getSelectedNodes();
    const selectedData = selectedNodes.find((node: any) => node.isSelected()).data;
    this.getIndexDetailsFor(selectedData.id);
  }

  initPaging(): void {
    this.pagingInfo.totalRows = this.rowData.length;
    this.pagingInfo.pageSize = 15;
    this.pagingInfo.visibleRows = 15;
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
  }

  changePage(): void{
    this.indexGrid.paginationGoToPage(this.pagingInfo.page);
    this.indexGrid.paginationSetPageSize(this.pagingInfo.pageSize);
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
  }

  formatDate(data: any): any{
    data.forEach((res: any) => {
      res.dailyReturn = res.dailyReturn ? (res.dailyReturn * 100).toFixed(4) : '';
      res.monthToDateReturn = res.monthToDateReturn ? (res.monthToDateReturn * 100).toFixed(4) : '';
      res.quarterToDateReturn = res.quarterToDateReturn ? (res.quarterToDateReturn * 100).toFixed(4) : '';
      res.yearToDateReturn = res.yearToDateReturn ? (res.yearToDateReturn * 100).toFixed(4) : '';
    });
    return data;
  }

  onSortChanged(event: any): void{
    const sortController = event.columnApi.getColumnState().find((col: any) => col.sort !== null);
    let tempCopy = JSON.parse(JSON.stringify(this.rowData));
    if (sortController) {
      const blankRows = this.rowData.filter((data: any) => data[sortController.colId] === '');
      if (blankRows.length > 0){
        blankRows.forEach((row: any) => {
          const index = tempCopy.findIndex((temp: any) => temp.indexName === row.indexName &&
            temp.inflationAdjustment === row.inflationAdjustment);
          tempCopy.splice(index, 1);
        });
      }
      tempCopy = this.sortDataBasedOn(tempCopy, sortController.colId, sortController.sort);
      if (sortController.sort === 'asc'){
        blankRows.forEach((row: any) => tempCopy.splice(0, 0, row));
      }else{
        blankRows.forEach((row: any) => tempCopy.push(row));
      }
      this.indexGrid.setRowData(tempCopy);
    }else{
      this.populateIndexData(this.rowData);
    }
  }

  sortDataBasedOn(data: any, columnName: string, order: string): any{
    if (order === 'asc'){
      if (columnName === 'fixing'){
        return data.sort((d1: any, d2: any) => {
          if (d1[columnName].toUpperCase() === 'FE_EOD' || d2[columnName].toUpperCase() === 'FE_EOD'){
            return d1[columnName].toUpperCase() === 'FE_EOD' ? -1 : 1;
          }
          if (d1[columnName].toUpperCase() === 'EU_EOD' || d2[columnName].toUpperCase() === 'EU_EOD'){
            return d1[columnName].toUpperCase() === 'EU_EOD' ? -1 : 1;
          }
          if (d1[columnName].toUpperCase() === 'US_EOD' || d2[columnName].toUpperCase() === 'US_EOD'){
            return d1[columnName].toUpperCase() === 'US_EOD' ? -1 : 1;
          }
          return 0;
        });
      }
      if (columnName === 'asOf'){
        return data.sort((d1: any, d2: any) => new Date(d1[columnName]).getTime() < new Date(d2[columnName]).getTime() ? -1 : 1);
      }
      return data.sort((d1: any, d2: any) => parseFloat(d1[columnName]) < parseFloat(d2[columnName]) ? -1 : 1);
    }else{
      if (columnName === 'fixing'){
        return data.sort((d1: any, d2: any) => {
          if (d1[columnName].toUpperCase() === 'US_EOD' || d2[columnName].toUpperCase() === 'US_EOD'){
            return d1[columnName].toUpperCase() === 'US_EOD' ? -1 : 1;
          }
          if (d1[columnName].toUpperCase() === 'EU_EOD' || d2[columnName].toUpperCase() === 'EU_EOD'){
            return d1[columnName].toUpperCase() === 'EU_EOD' ? -1 : 1;
          }
          if (d1[columnName].toUpperCase() === 'FE_EOD' || d2[columnName].toUpperCase() === 'FE_EOD'){
            return d1[columnName].toUpperCase() === 'FE_EOD' ? -1 : 1;
          }
          return 0;
        });
      }
      if (columnName === 'asOf'){
        return data.sort((d1: any, d2: any) => new Date(d1[columnName]).getTime() > new Date(d2[columnName]).getTime() ? -1 : 1);
      }
      return data.sort((d1: any, d2: any) => parseFloat(d1[columnName]) < parseFloat(d2[columnName]) ? 1 : -1);
    }
  }

  getIndexDetailsFor(identifier: string): void {
    this.route.navigateByUrl('UCITS/index?id=' + identifier);

  }

  goToLink(link: string): void {
    switch (link) {
      case 'iBoxx@markit.com':
        window.location.href = 'mailto: iBoxx@markit.com?subject=files&body=';
        break;
      case 'http://www.markit.com/Documentation/Product/IBoxx/Rules_Benchmark':
        window.open(link, '_blank');
        break;
    }
  }
}
